import Branding from './Branding';
import Footer from './Footer';
import FormField from './FormField';
import Header from './Header';
import HeaderAlt from './HeaderAlt';
import Navigation from './Navigation';
import Layout from './Layout';

export {
    Branding,
    Footer,
    FormField,
    Header,
    HeaderAlt,
    Navigation,
    Layout
};

export default {
    Branding,
    Footer,
    FormField,
    Header,
    HeaderAlt,
    Navigation,
    Layout
};
